import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Loader2 } from 'lucide-react';
import ClientSubRegionsPanel from '../components/ClientSubRegionsPanel';
import { clientsService } from '../services';

export default function ClientSubRegionsPage() {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clientId) return;
    clientsService.get(parseInt(clientId))
      .then(data => setClient(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [clientId]);

  if (loading) return <div className="p-6 text-center"><Loader2 className="h-5 w-5 animate-spin inline mr-2" />Loading...</div>;

  return (
    <div className="p-6 max-w-4xl mx-auto space-y-4" data-testid="client-sub-regions-page">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate(-1)} data-testid="back-btn">
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div>
          <h1 className="text-lg font-semibold">{client?.name || 'Client'} — Sub-Regions</h1>
          <p className="text-xs text-muted-foreground">Organise sites into named regions for regional manager portal access</p>
        </div>
      </div>
      <ClientSubRegionsPanel clientId={parseInt(clientId)} clientName={client?.name || 'Client'} />
    </div>
  );
}
